import type { ThemeNavItemHeaderSwitch } from '@fordeerTheme/components/buttons/getThemeNavItems'
import type { CollapsibleRequiredPlan } from '@components/CollapsibleList/types'
import { PlanOptions, type TPlanOptions } from '@constant'

type SubscriptionLike = {
  type_app?: string
  /** API `ShopPolicy#from_pro?` = STARTER|PROFESSIONAL|PREMIUM (Starter+), KHÔNG phải quyền Professional. */
  from_pro?: boolean
  /** API `ShopPolicy#pre?` = PREMIUM. */
  pre?: boolean
  /** Shopify Plus store flag (từ check_shop_plus). */
  shopify_plus?: boolean
} | null | undefined

/**
 * Resolve gói tối thiểu cho L1 Navigate / OptionPanelHeader L2.
 * `disableOnFree` tương đương Starter+.
 */
export function resolveNavRequiredPlan(
  headerSwitch?: ThemeNavItemHeaderSwitch | null,
): CollapsibleRequiredPlan | undefined {
  if (!headerSwitch) return undefined
  if (headerSwitch.requiredPlan) return headerSwitch.requiredPlan
  if (headerSwitch.disableOnFree) return PlanOptions.Starter
  return undefined
}

/** Map plan badge ItemMarkup → requiredPlan CollapsibleList. */
export function requiredPlanFromBadge(plan?: {
  start?: boolean
  pro?: boolean
  pre?: boolean
}): CollapsibleRequiredPlan | undefined {
  if (!plan) return undefined
  if (plan.start) return PlanOptions.Starter
  if (plan.pro) return PlanOptions.Professional
  if (plan.pre) return PlanOptions.Premium
  return undefined
}

/** Professional hoặc Premium — dùng khoá feature Pro (Gift cards, metafields…). */
export function isProfessionalOrHigher(
  subscription: SubscriptionLike,
): boolean {
  return (
    subscription?.type_app === PlanOptions.Professional ||
    subscription?.type_app === PlanOptions.Premium
  )
}

/**
 * Starter trở lên. Tương đương API `from_pro` (tên lịch sử — không = Professional).
 */
export function isStarterOrHigher(subscription: SubscriptionLike): boolean {
  const type = subscription?.type_app
  return (
    type === PlanOptions.Starter ||
    type === PlanOptions.Professional ||
    type === PlanOptions.Premium ||
    Boolean(subscription?.from_pro)
  )
}

/**
 * Setting có `requiredPlan` có bị khoá với subscription hiện tại không.
 * Dùng chung cho `disabled` + hiện `TextPlan` — không dùng `from_pro` cho Professional.
 */
export function isPlanLocked(
  subscription: SubscriptionLike,
  requiredPlan: CollapsibleRequiredPlan | TPlanOptions | undefined,
): boolean {
  if (!requiredPlan) return false
  if (requiredPlan === PlanOptions.Starter) {
    return subscription?.type_app === PlanOptions.Free
  }
  if (requiredPlan === PlanOptions.Professional) {
    return !isProfessionalOrHigher(subscription)
  }
  if (requiredPlan === PlanOptions.Premium) {
    return (
      subscription?.type_app !== PlanOptions.Premium &&
      !Boolean(subscription?.pre)
    )
  }
  if (requiredPlan === 'SHOPIFY_PLUS') {
    return !Boolean(subscription?.shopify_plus)
  }
  return false
}
